import React from "react";
import "../App.css";
import GameScreen from "../assets/aboutGame.png";

export const AboutGame = ({ t }) => {
  const copy = t.about;

  return (
    <div className="i">
      <div className="i-left">
        <img className="main" src={GameScreen} alt={copy.imageAlt} />
      </div>
      <div className="i-right">
        <div className="about-project">
          <h1>{copy.title}</h1>
            <div className="hud-card">
                <div className="hud-text">
            {copy.text}
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default AboutGame;
